
/** Determine if the user has been idle for longer than a given threshold.
 *	@param {Number} threshold	A set amount of time after which, if there are no events, we consider the user idle.
 *	@returns {Bool}
 */

let timeOfLastEvent = Date.now(),
	events = ['scroll', 'mousedown', 'mousemove', 'keydown', 'touchstart'],
	initialized = false;

export default function isIdle(threshold = 60000) {
	if (!initialized) {
		for (let i = 0; i < events.length; i++) {
			window.addEventListener(events[i], registerEvent);
		}

		initialized = true;
	}

	let delta = Date.now() - timeOfLastEvent;

	if (delta > threshold) {
		return true;
	}

	return false;
}

function registerEvent(e) {
	timeOfLastEvent = Date.now();
}
